module.exports = __webpack_public_path__ + "img/man-kedo.db4063c1.png";